module.exports = __webpack_public_path__ + "img/9cf1b0a.png";